import { Checkbox, Fieldset, Group, Stack, Text } from '@mantine/core';
import { PropsWithChildren } from 'react';

type RequiredSettingProps = PropsWithChildren & {
  title: string;
};

export function RequiredSetting({ children, title }: RequiredSettingProps) {
  return (
    <Group align='flex-start' pos='relative' gap='sm'>
      <Checkbox checked={true} disabled={true} />
      <Fieldset variant='unstyled'>
        <Stack>
          <Text fw={600}>{title}</Text>
          {children}
        </Stack>
      </Fieldset>
    </Group>
  );
}
